import { useState } from "react";
import logo from "../../assets/mundialito.png";
import { FaTrophy } from "react-icons/fa";

export default function Invernal() {
  const [seccionActiva, setSeccionActiva] = useState("resultados");
  const [fechaSeleccionada, setFechaSeleccionada] = useState(1);

  const tablaPosiciones = [
    {
      posicion: 1,
      equipo: "Simplemente Futbol",
      PJ: 2,
      PG: 2,
      PE: 0,
      PP: 0,
      GF: 8,
      GC: 1,
      DG: 7,
      PTS: 6,
    },
    {
      posicion: 2,
      equipo: "Josema FC",
      PJ: 2,
      PG: 2,
      PE: 0,
      PP: 0,
      GF: 8,
      GC: 1,
      DG: 7,
      PTS: 6,
    },
    {
      posicion: 3,
      equipo: "Amigos de Perreke Fc",
      PJ: 2,
      PG: 2,
      PE: 0,
      PP: 0,
      GF: 8,
      GC: 2,
      DG: 6,
      PTS: 6,
    },
    {
      posicion: 4,
      equipo: "SF LA 27",
      PJ: 1,
      PG: 1,
      PE: 0,
      PP: 0,
      GF: 2,
      GC: 1,
      DG: 1,
      PTS: 3,
    },
    {
      posicion: 5,
      equipo: "Porvenir Fc",
      PJ: 2,
      PG: 1,
      PE: 0,
      PP: 1,
      GF: 5,
      GC: 7,
      DG: -2,
      PTS: 3,
    },
    {
      posicion: 6,
      equipo: "Adonis kaleth Fc",
      PJ: 2,
      PG: 0,
      PE: 1,
      PP: 1,
      GF: 2,
      GC: 3,
      DG: -1,
      PTS: 1,
    },
    {
      posicion: 7,
      equipo: "J.Cuenca Pesquera",
      PJ: 2,
      PG: 0,
      PE: 1,
      PP: 1,
      GF: 1,
      GC: 3,
      DG: -2,
      PTS: 1,
    },
    {
      posicion: 8,
      equipo: "La Verdad Os Hará Libre",
      PJ: 1,
      PG: 0,
      PE: 0,
      PP: 1,
      GF: 1,
      GC: 3,
      DG: -2,
      PTS: 0,
    },
    {
      posicion: 9,
      equipo: "Almac-Redbull Fc",
      PJ: 2,
      PG: 0,
      PE: 0,
      PP: 2,
      GF: 2,
      GC: 6,
      DG: -4,
      PTS: 0,
    },
    {
      posicion: 10,
      equipo: "Afganistán FC",
      PJ: 1,
      PG: 0,
      PE: 0,
      PP: 1,
      GF: 0,
      GC: 5,
      DG: -5,
      PTS: 0,
    },
    {
      posicion: 11,
      equipo: "Deportivo del Valle - Eliminado",
    },
  ];

  const resultados = [
    {
      fecha1: {
        descripcion: "Fecha 1",
        partidos: [
          {
            equipo1: "Simplemente Futbol",
            goles1: 5,
            equipo2: "Leones FC",
            goles2: 0,
          },
          {
            equipo1: "Amigos de Perreke Fc",
            goles1: 6,
            equipo2: "Porvenir Fc",
            goles2: 2,
          },
          {
            equipo1: "Josema FC",
            goles1: 3,
            equipo2: "Almac-Redbull Fc",
            goles2: 1,
          },
          {
            equipo1: "J.Cuenca Pesquera",
            goles1: 0,
            equipo2: "Adonis kaleth Fc",
            goles2: 0,
          },
          {
            equipo1: "La Verdad Os Hará Libre",
            goles1: " ",
            equipo2: "Afganistán FC",
            goles2: "",
          },
        ],
      },
      fecha2: {
        descripcion: "Fecha 2",
        partidos: [
          {
            equipo1: "SF LA",
            goles1: 27,
            equipo2: "Adonis Kaleth Fc",
            goles2: 2,
          },
          {
            equipo1: "Porvenir Fc",
            goles1: 3,
            equipo2: "La Verdad Os Hará Libre",
            goles2: 1,
          },
          {
            equipo1: "J. Cuenca Pesquera",
            goles1: 0,
            equipo2: "Amigos de Perreke Fc",
            goles2: 2,
          },
          {
            equipo1: "Josema FC",
            goles1: 5,
            equipo2: "Afganistán FC",
            goles2: 0,
          },
          {
            equipo1: "Simplemente Futbol",
            goles1: 3,
            equipo2: "Almac-Redbull Fc",
            goles2: 1,
          },
        ],
      },
      fecha3: {
        descripcion: "3ERA FECHA DOMINGO, 30 DE MARZO 2025 (CANCHA NATURAL)",
        partidos: [
          {
            hora: "11:45",
            equipo1: "Josema FC",
            goles1: "-",
            equipo2: "Simplemente Futbol",
            goles2: "-",
          },
          {
            hora: "13:15",
            equipo1: "Porvenir Fc",
            goles1: "-",
            equipo2: "SF LA 27",
            goles2: "-",
          },
          {
            hora: "14:30",
            equipo1: "ALMAC Red Bull",
            goles1: "-",
            equipo2: "AMIGOS DE PERREKE",
            goles2: "-",
          },
          {
            hora: "15:45",
            equipo1: "ADONIS KALETH",
            goles1: "-",
            equipo2: "AFGANISTAN FC",
            goles2: "-",
          },
          {
            hora: "No Programado",
            equipo1: "Deportivo del Valle",
            goles1: "-",
            equipo2: "LA VERDAD OS HARA LIBRE",
            goles2: "-",
          },
          {
            equipo1: "J. CUENCA PESQUERA",
            goles1: "-",
            equipo2: "LIBRE",
            goles2: "-",
          },
        ],
      },
    },
  ];

  const goleadores = [
    {
      posicion: 1,
      nombre: "QUIROZ AVEIGA ANTHONY STEVEN",
      equipo: "AMIGOS DE PERREKE",
      goles: 3,
    },
    {
      posicion: 2,
      nombre: "ALAVA MACIAS ANGEL EDMUNDO",
      equipo: "ALMAC RED-BULL MANTA",
      goles: 2,
    },
    {
      posicion: 3,
      nombre: "CABAL RUBIO KEVIN YAREL",
      equipo: "AMIGOS DE PERREKE",
      goles: 2,
    },
    {
      posicion: 4,
      nombre: "LOOR BRAVO MICHAEL DANIEL",
      equipo: "JOSEMA FC",
      goles: 2,
    },
    {
      posicion: 5,
      nombre: "VEGA GASPAR JOE MIGUEL",
      equipo: "SIMPLEMENTE FUTBOL",
      goles: 2,
    },
  ];

  const sancionesf1 = [
    {
      fecha: "1",
      jugador: "CHARCOPA QUIÑONEZ MICHAEL ROBERTO",
      equipo: "ADONIS KALETH FC.",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "MOREIRA GRACIA RODDY MILCIADES",
      equipo: "ADONIS KALETH FC.",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "PAIVA FALCONEZ ANDERSON JACINTO",
      equipo: "AMIGOS DE PERREKE",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "QUIROZ AVEIGA ANTHONY STEVEN",
      equipo: "AMIGOS DE PERREKE",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "VELEZ RODRÍGUEZ EDU NICOLÁS",
      equipo: "CLUB DEPORTIVO DEL VALLE",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "BURGO SALTOS NIXON RICARDO",
      equipo: "EL PORVENIR FC",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "VÉLEZ VÉLEZ EDY ROYER",
      equipo: "EL PORVENIR FC",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "DELGADO GARCÍA CRISTHOFER BRUNO",
      equipo: "J. CUENCA PESQUERA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "MACÍAS PALMA JEISON DARLIN",
      equipo: "J. CUENCA PESQUERA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "BARBERÁN MANTILLA MARLON ANDRÉS",
      equipo: "JOSEMA FC",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "1",
      jugador: "CEDEÑO ELVIS",
      equipo: "J. CUENCA PESQUERA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
  ];

  const sancionesf2 = [
    {
      fecha: "2",
      jugador: "ALCIVAR VALDERRAMO ERVIN JOSÉ",
      equipo: "ADONIS KALETH FC.",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "MERO ZAMBRANO NEY GABRIEL",
      equipo: "ADONIS KALETH FC.",
      ta: "0",
      tr: "1",
      motivo: "ROJA DIRECTA",
      suspension: "2",
    },
    {
      fecha: "2",
      jugador: "PARRAGA MORÁN JULIO CÉSAR",
      equipo: "ADONIS KALETH FC.",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "CEVALLOS CHAVEZ ROBERTO AGUSTIN",
      equipo: "ALMAC RED-BULL MANTA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "MACIAS PICO JOSE JAVIER",
      equipo: "ALMAC RED-BULL MANTA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "MACIAS VERA WILSON ALEJANDRO",
      equipo: "ALMAC RED-BULL MANTA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "NAZARENO ARCE CARLOS ENRIQUE",
      equipo: "ALMAC RED-BULL MANTA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "CEVALLOS BORRERO DENNYS V.",
      equipo: "AMIGOS DE PERREKE",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "QUIROZ AVEIGA ANTHONY STEVEN",
      equipo: "AMIGOS DE PERREKE",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "MOREIRA QUIMIS MAYCKEL IBIS",
      equipo: "EL PORVENIR FC",
      ta: "2",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "VÉLEZ VÉLEZ EDY ROYER",
      equipo: "EL PORVENIR FC",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "CUENCA BURGOS CRISTHOFFER JESUS",
      equipo: "J. CUENCA PESQUERA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "CUENCA CEDEÑO ERICK GABRIEL",
      equipo: "J. CUENCA PESQUERA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "DELGADO GARCÍA CRISTHOFER BRUNO",
      equipo: "J. CUENCA PESQUERA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "ZAMBRANO SALVATIERRA DIEGO J.",
      equipo: "J. CUENCA PESQUERA",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "GUZMÁN SANCHEZ HUGO MANUEL",
      equipo: "SF 27",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "VÉLEZ MERA GREGORY",
      equipo: "SF 27",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "PACHECO HERRERA ANTHONY PAUL",
      equipo: "SIMPLEMENTE FUTBOL",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "HOLGUIN ALVIA BRAYAN",
      equipo: "SF 27",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
    {
      fecha: "2",
      jugador: "MERA MOLINA JHONNY",
      equipo: "EL PORVENIR FC",
      ta: "1",
      tr: "0",
      motivo: "",
      suspension: "0",
    },
  ];

  return (
    <div className="p-6 bg-gradient-to-b from-blue-900 to-blue-600 min-h-screen text-white">
      {/* Logo */}
      <div className="flex justify-center mb-6">
        <FaTrophy className="text-yellow-400 text-5xl" />
      </div>

      {/* Botones de navegación */}
      <div className="flex justify-center items-center w-full">
        <div className="flex w-full max-w-4xl space-x-4 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory justify-center">
          <button
            className={`px-6 py-2 whitespace-nowrap rounded-lg text-sm font-bold transition-all snap-center ${
              seccionActiva === "resultados"
                ? "bg-white text-blue-900"
                : "bg-blue-700 hover:bg-blue-500"
            }`}
            onClick={() => setSeccionActiva("resultados")}
          >
            Resultados
          </button>
          <button
            className={`px-6 py-2 whitespace-nowrap rounded-lg text-sm font-bold transition-all snap-center ${
              seccionActiva === "tabla"
                ? "bg-white text-blue-900"
                : "bg-blue-700 hover:bg-blue-500"
            }`}
            onClick={() => setSeccionActiva("tabla")}
          >
            Tabla
          </button>
          <button
            className={`px-6 py-2 whitespace-nowrap rounded-lg text-sm font-bold transition-all snap-center ${
              seccionActiva === "sanciones"
                ? "bg-white text-blue-900"
                : "bg-blue-700 hover:bg-blue-500"
            }`}
            onClick={() => setSeccionActiva("sanciones")}
          >
            Sanciones
          </button>
          <button
            className={`px-6 py-2 whitespace-nowrap rounded-lg text-sm font-bold transition-all snap-center ${
              seccionActiva === "goleadores"
                ? "bg-white text-blue-900"
                : "bg-blue-700 hover:bg-blue-500"
            }`}
            onClick={() => setSeccionActiva("goleadores")}
          >
            Goleadores
          </button>
        </div>
      </div>

      {/* Contenido dinámico */}
      <div className="max-w-4xl mx-auto bg-white text-gray-900 p-4 sm:p-6 shadow-2xl rounded-2xl">
        {seccionActiva === "resultados" && (
          <div className="max-w-full px-1 sm:px-2.5 font-sans">
            {/* Título principal */}
            <h2 className="bg-gradient-to-br from-blue-900 to-blue-600 text-white text-center text-xl sm:text-2xl font-black py-3 sm:py-4 mb-4 sm:mb-5 rounded-lg shadow-md uppercase tracking-wide">
              Fechas
            </h2>

            {/* Iterar sobre las fechas */}
            {Object.keys(resultados[0])
              .reverse()
              .map((fecha, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-md overflow-hidden mb-5 sm:mb-6"
                >
                  {/* Encabezado de fecha */}
                  <div className="bg-gray-50 px-3 sm:px-4 py-2 sm:py-3 border-b-2 border-gray-200">
                    {resultados[0][fecha].descripcion ? (
                      <h3 className="text-gray-800 text-base sm:text-lg font-bold text-center">
                        {resultados[0][fecha].descripcion}
                      </h3>
                    ) : (
                      <h3 className="text-gray-800 text-base sm:text-lg font-bold text-center">
                        Fecha {index + 1}
                      </h3>
                    )}
                  </div>

                  {/* Lista de partidos */}
                  <ul className="divide-y divide-gray-100">
                    {Array.isArray(resultados[0][fecha].partidos) ? (
                      resultados[0][fecha].partidos.map((partido, idx) => (
                        <li key={idx} className="p-3 sm:p-4">
                          {/* Hora del partido */}
                          <div className="text-gray-500 text-xs sm:text-sm font-semibold text-center mb-1 sm:mb-2">
                            {partido.hora || "---"}
                          </div>

                          {/* Contenedor equipos y marcador */}
                          <div className="flex items-center justify-between">
                            {/* Equipo local */}
                            <div className="flex-1 text-right pr-1 sm:pr-2">
                              <span className="text-gray-800 font-semibold text-xs sm:text-sm">
                                {partido.equipo1}
                              </span>
                            </div>

                            {/* Marcador */}
                            <div className="min-w-[60px] sm:min-w-[80px] bg-gray-50 rounded-md py-1 sm:py-2 px-1 text-center">
                              {partido.estado ? (
                                <span className="text-blue-900 font-bold text-sm sm:text-lg">
                                  {partido.estado}
                                </span>
                              ) : (
                                <div className="flex justify-center items-center">
                                  <span className="text-blue-900 font-bold text-sm sm:text-lg w-4 sm:w-5">
                                    {partido.goles1}
                                  </span>
                                  <span className="mx-0.5 sm:mx-1 text-blue-900 font-bold text-xs sm:text-base">
                                    vs
                                  </span>
                                  <span className="text-blue-900 font-bold text-sm sm:text-lg w-4 sm:w-5">
                                    {partido.goles2}
                                  </span>
                                </div>
                              )}
                            </div>

                            {/* Equipo visitante */}
                            <div className="flex-1 text-left pl-1 sm:pl-2">
                              <span className="text-gray-800 font-semibold text-xs sm:text-sm">
                                {partido.equipo2}
                              </span>
                            </div>
                          </div>
                        </li>
                      ))
                    ) : (
                      <li className="py-4 sm:py-5 text-center text-gray-500 italic text-sm">
                        No hay partidos disponibles
                      </li>
                    )}
                  </ul>
                </div>
              ))}
          </div>
        )}

        {/* Resto de tus secciones (tabla, sanciones, goleadores) permanecen igual */}
        {seccionActiva === "tabla" && (
          <div className="text-gray-900 p-4 sm:p-6 rounded-2xl max-w-4xl mx-auto">
            <h2 className="text-2xl sm:text-3xl font-extrabold mb-4 sm:mb-6 text-center text-blue-900 uppercase">
              Tabla de posiciones
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse text-xs sm:text-sm shadow-md">
                <thead>
                  <tr className="bg-blue-800 text-white text-center uppercase text-xs">
                    <th className="p-2 sm:p-3 sticky left-0 bg-blue-800">
                      Pos
                    </th>
                    <th className="p-2 sm:p-3 text-left sticky left-[40px] bg-blue-800">
                      Equipo
                    </th>
                    <th className="p-2 sm:p-3 min-w-[40px] sm:min-w-[50px]">
                      PJ
                    </th>
                    <th className="p-2 sm:p-3 min-w-[40px] sm:min-w-[50px]">
                      PG
                    </th>
                    <th className="p-2 sm:p-3 min-w-[40px] sm:min-w-[50px]">
                      PE
                    </th>
                    <th className="p-2 sm:p-3 min-w-[40px] sm:min-w-[50px]">
                      PP
                    </th>
                    <th className="p-2 sm:p-3 min-w-[40px] sm:min-w-[50px]">
                      GF
                    </th>
                    <th className="p-2 sm:p-3 min-w-[40px] sm:min-w-[50px]">
                      GC
                    </th>
                    <th className="p-2 sm:p-3 min-w-[40px] sm:min-w-[50px]">
                      DG
                    </th>
                    <th className="p-2 sm:p-3 min-w-[40px] sm:min-w-[50px]">
                      PTS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tablaPosiciones.map((equipo, idx) => (
                    <tr
                      key={idx}
                      className={`text-center border-b ${
                        idx % 2 === 0 ? "bg-gray-100" : "bg-gray-200"
                      }`}
                    >
                      <td className="p-2 sm:p-3 font-bold text-blue-800 sticky left-0 bg-white">
                        {equipo.posicion}
                      </td>
                      <td className="p-2 sm:p-3 text-left font-semibold sticky left-[40px] bg-white">
                        {equipo.equipo}
                      </td>
                      <td className="p-2 sm:p-3">{equipo.PJ}</td>
                      <td className="p-2 sm:p-3">{equipo.PG}</td>
                      <td className="p-2 sm:p-3">{equipo.PE}</td>
                      <td className="p-2 sm:p-3">{equipo.PP}</td>
                      <td className="p-2 sm:p-3">{equipo.GF}</td>
                      <td className="p-2 sm:p-3">{equipo.GC}</td>
                      <td className="p-2 sm:p-3 font-semibold">{equipo.DG}</td>
                      <td className="p-2 sm:p-3 font-bold text-lg sm:text-xl text-blue-800">
                        {equipo.PTS}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {seccionActiva === "sanciones" && (
          <div>
            <h2 className="text-2xl sm:text-3xl font-extrabold mb-4 sm:mb-6 text-center text-blue-900 uppercase">
              Tarjetas y Sanciones
            </h2>

            {/* Scroll horizontal para seleccionar la fecha */}
            <div className="flex space-x-2 sm:space-x-4 overflow-x-auto pb-2 mb-3 sm:mb-4">
              <button
                className={`px-3 py-1 sm:px-4 sm:py-2 border rounded-lg text-xs sm:text-base ${
                  fechaSeleccionada === 1
                    ? "bg-red-800 text-white"
                    : "bg-gray-200"
                }`}
                onClick={() => setFechaSeleccionada(1)}
              >
                Fecha 1
              </button>
              <button
                className={`px-3 py-1 sm:px-4 sm:py-2 border rounded-lg text-xs sm:text-base ${
                  fechaSeleccionada === 2
                    ? "bg-red-800 text-white"
                    : "bg-gray-200"
                }`}
                onClick={() => setFechaSeleccionada(2)}
              >
                Fecha 2
              </button>
            </div>

            <div className="max-w-full overflow-x-auto md:overflow-x-visible">
              <table className="w-full border-collapse text-xs sm:text-sm shadow-md min-w-[600px] sm:min-w-[720px]">
                <thead>
                  <tr className="bg-red-800 text-white text-center uppercase text-xs">
                    <th className="p-2 sm:p-3">Fecha</th>
                    <th className="p-2 sm:p-3">Jugador</th>
                    <th className="p-2 sm:p-3">Equipo</th>
                    <th className="p-2 sm:p-3">TA</th>
                    <th className="p-2 sm:p-3">TR</th>
                    <th className="p-2 sm:p-3">Motivo</th>
                    <th className="p-2 sm:p-3">Suspensión</th>
                  </tr>
                </thead>
                <tbody>
                  {(fechaSeleccionada === 1 ? sancionesf1 : sancionesf2).map(
                    (sancion, idx) => (
                      <tr
                        key={idx}
                        className={`text-center border-b ${
                          idx % 2 === 0 ? "bg-gray-100" : "bg-gray-200"
                        }`}
                      >
                        <td className="p-2 sm:p-3">{sancion.fecha}</td>
                        <td className="p-2 sm:p-3 text-start font-semibold">
                          {sancion.jugador}
                        </td>
                        <td className="p-2 sm:p-3">{sancion.equipo}</td>
                        <td className="p-2 sm:p-3">{sancion.ta}</td>
                        <td className="p-2 sm:p-3">{sancion.tr}</td>
                        <td className="p-2 sm:p-3">{sancion.motivo}</td>
                        <td className="p-2 sm:p-3 font-bold text-red-600">
                          {sancion.suspension}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {seccionActiva === "goleadores" && (
          <div className="text-gray-900 p-4 sm:p-6 rounded-2xl max-w-4xl mx-auto">
            <h2 className="text-2xl sm:text-3xl font-extrabold mb-4 sm:mb-6 text-center text-blue-900 uppercase">
              Goleadores
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse text-xs sm:text-sm shadow-md">
                <thead>
                  <tr className="bg-blue-800 text-white text-center uppercase text-xs">
                    <th className="p-2 sm:p-3">Pos</th>
                    <th className="p-2 sm:p-3 text-left">Nombre</th>
                    <th className="p-2 sm:p-3">Equipo</th>
                    <th className="p-2 sm:p-3">Goles</th>
                  </tr>
                </thead>
                <tbody>
                  {goleadores.map((goleador, idx) => (
                    <tr
                      key={idx}
                      className={`text-center border-b ${
                        idx % 2 === 0 ? "bg-gray-100" : "bg-gray-200"
                      }`}
                    >
                      <td className="p-2 sm:p-3 font-bold text-blue-800">
                        {goleador.posicion}
                      </td>
                      <td className="p-2 sm:p-3 text-left font-semibold">
                        {goleador.nombre}
                      </td>
                      <td className="p-2 sm:p-3">{goleador.equipo}</td>
                      <td className="p-2 sm:p-3">{goleador.goles}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
